import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Tasklogin from '@assets/svg/Task_login.svg?react';
import Tasklogout from '@assets/svg/Task_logout.svg?react';
import Taskmoon from '@assets/svg/Task_moon.svg?react';
import TaskUser from '@assets/svg/Task_user.svg?react';

interface IStatsCardsProps {
  checkInTodayCount: number;
  checkOutTodayCount: number;
  upcomingCount: number;
  vacantTodayCount: number;
  isLoading?: boolean;
}

interface IStatCard {
  icon: React.ReactNode;
  label: string;
  sublabel?: string;
  value: number;
}

const StatCard = ({ icon, label, sublabel, value }: IStatCard) => (
  <Box
    sx={{
      flex: '1 1 200px',
      backgroundColor: '#FFFFFF',
      borderRadius: '16px',
      padding: '24px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      height: '100%',
    }}
  >
    <Typography
      sx={{
        fontFamily: 'Tajawal, sans-serif',
        fontWeight: 400,
        fontSize: '14px',
        color: '#435363',
        whiteSpace: 'nowrap',
      }}
    >
      {sublabel ? `${sublabel} · ${label}` : label}
    </Typography>
    <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', minWidth: '100%', height: '100%' }}>
      <Typography
          sx={{
            fontFamily: 'Tajawal, sans-serif',
            fontWeight: 700,
            fontSize: '32px',
            color: '#5B3FFF',
            lineHeight: '1',
            paddingTop: '18px',
          }}
        >
          {value}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0, paddingBottom: '8px' }}>
          {icon}
        </Box>
    </Box>
  </Box>
);

const StatsCards = ({
  checkInTodayCount,
  checkOutTodayCount,
  upcomingCount,
  vacantTodayCount,
}: IStatsCardsProps) => {
  const { t } = useTranslation();

  const cards: IStatCard[] = [
    {
      icon: <Tasklogin style={{ width: 32, height: 32 }} />,
      label: t('TaskManagemnt.checkinToday'),
      sublabel: t('TaskManagemnt.today'),
      value: checkInTodayCount,
    },
    {
      icon: <Tasklogout style={{ width: 32, height: 32 }} />,
      label: t('TaskManagemnt.checkoutToday'),
      sublabel: t('TaskManagemnt.today'),
      value: checkOutTodayCount,
    },
    {
      icon: <TaskUser style={{ width: 32, height: 32 }} />,
      label: t('TaskManagemnt.upcoming'),
      value: upcomingCount,
    },
    {
      icon: <Taskmoon style={{ width: 32, height: 32 }} />,
      label: t('TaskManagemnt.vacantUnits'),
      sublabel: t('TaskManagemnt.today'),
      value: vacantTodayCount,
    },
  ];

  return (
    <Grid container spacing={2}>
      {cards.map((card, i) => (
        <Grid item xs={12} sm={6} md={3} key={i}>
          <StatCard {...card} />
        </Grid>
      ))}
    </Grid>
  );
};

export default StatsCards;
